(() => {
  if (window.AGFav) return;

  const API = '/apps/favoritos';
  const KEY = 'ag_fav_device';
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

  const favs = new Set();
  const pending = new Set();

  // ---------- Identificador del dispositivo ----------
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    const b = crypto.getRandomValues(new Uint8Array(16));
    b[6] = (b[6] & 15) | 64;
    b[8] = (b[8] & 63) | 128;
    const h = [...b].map(x => x.toString(16).padStart(2, '0')).join('');
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
  }

  function getDevice() {
    let id = null;
    try { id = localStorage.getItem(KEY); } catch (e) {}
    if (!id) {
      const m = document.cookie.match(/(?:^|; )ag_fav_device=([^;]+)/);
      if (m) id = m[1];
    }
    if (!id || !/^[A-Za-z0-9-]{8,64}$/.test(id)) id = uuid();
    try { localStorage.setItem(KEY, id); } catch (e) {}
    document.cookie = `${KEY}=${id}; max-age=31536000; path=/; SameSite=Lax`;
    return id;
  }

  const DEVICE = getDevice();

  // ---------- Origen del clic ----------
  function source(btn) {
    if (btn.dataset.favSource) return btn.dataset.favSource;
    const p = location.pathname;
    if (p.startsWith('/pages/buscador')) return 'buscador';
    if (p.startsWith('/pages/favoritos')) return 'pagina_favoritos';
    if (p.includes('/products/')) return 'producto';
    if (p.includes('/collections/')) return 'coleccion';
    return 'otro';
  }

  // ---------- Pintado ----------
  function paintBtn(btn) {
    if (!btn.querySelector('svg')) {
      btn.insertAdjacentHTML('afterbegin', HEART);
      if (btn.classList.contains('ag-fav-btn--inline')) {
        btn.insertAdjacentHTML('beforeend', '<span class="ag-fav-label"></span>');
      }
    }
    const on = favs.has(String(btn.dataset.favId));
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Quitar de favoritos' : 'Agregar a favoritos');
    const lbl = btn.querySelector('.ag-fav-label');
    if (lbl) lbl.textContent = on ? 'En tus favoritos' : 'Agregar a favoritos';
  }

  function paintCount() {
    const n = favs.size;
    document.querySelectorAll('[data-ag-fav-count]').forEach(el => {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
    });
  }

  function paint(root = document) {
    root.querySelectorAll('.ag-fav-btn').forEach(paintBtn);
    paintCount();
  }

  function paintId(id) {
    document.querySelectorAll(`.ag-fav-btn[data-fav-id="${id}"]`).forEach(paintBtn);
  }

  // ---------- API ----------
  async function post(path, data) {
    const r = await fetch(API + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ device_id: DEVICE, ...data })
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok || !j.ok) throw new Error(j.error || 'HTTP ' + r.status);
    return j;
  }

  // ---------- Etiqueta oculta en el carrito (detecta compras sin sesión) ----------
  async function syncCartDevice() {
    if (!favs.size) return;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      if (cart.attributes && cart.attributes._ag_fav_device === DEVICE) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _ag_fav_device: DEVICE } })
      });
    } catch (e) {}
  }

  async function load() {
    try {
      const r = await fetch(`${API}/list?device_id=${encodeURIComponent(DEVICE)}`);
      const j = await r.json();
      favs.clear();
      (j.ids || []).forEach(id => favs.add(String(id)));
      window.AGFav.loggedIn = !!j.logged_in;
      window.AGFav.data = j;
    } catch (e) {
      console.warn('[AGFav] no se pudieron cargar los favoritos', e);
      window.AGFav.data = null;
    }
    paint();
    document.dispatchEvent(new CustomEvent('agfav:ready'));
    syncCartDevice();
  }

  async function toggle(btn) {
    const id = String(btn.dataset.favId || '');
    if (!/^\d+$/.test(id) || pending.has(id)) return;
    pending.add(id);

    const adding = !favs.has(id);
    adding ? favs.add(id) : favs.delete(id);
    paintId(id);
    paintCount();

    if (adding) {
      btn.classList.remove('ag-fav-pop');
      void btn.offsetWidth;
      btn.classList.add('ag-fav-pop');
    }

    try {
      const d = btn.dataset;
      if (adding) {
        await post('/add', {
          product_id: id,
          variant_id: d.favVariant,
          handle: d.favHandle,
          title: d.favTitle,
          image: d.favImage,
          price: d.favPrice,
          source: source(btn)
        });
      } else {
        await post('/remove', { product_id: id, source: source(btn) });
      }
      document.dispatchEvent(new CustomEvent('agfav:change', { detail: { id, active: adding } }));
      if (adding) showLoginPrompt();
    } catch (e) {
      adding ? favs.delete(id) : favs.add(id);
      paintId(id);
      paintCount();
      console.warn('[AGFav] error al guardar', e);
    } finally {
      pending.delete(id);
    }
  }

  // ---------- Detección por coordenadas (el enlace de Dawn tapa el botón en PC) ----------
  function hitFav(e) {
    if (!e.clientX && !e.clientY) return null;
    const card = e.target.closest && e.target.closest('.card-wrapper, .grid__item');
    if (!card) return null;
    const btn = card.querySelector('.ag-fav-btn');
    if (!btn) return null;
    const r = btn.getBoundingClientRect();
    const inside = e.clientX >= r.left - 2 && e.clientX <= r.right + 2 &&
                   e.clientY >= r.top - 2 && e.clientY <= r.bottom + 2;
    return inside ? btn : null;
  }

  // ---------- HTML del botón para tarjetas armadas por JS ----------
  function btnHTML(p, src) {
    const id = String(p.id || p.product_id || '').split('/').pop();
    if (!/^\d+$/.test(id)) return '';
    const e = v => String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const rawPrice = p.price != null ? p.price : p.price_at_add;
    const price = parseInt(String(rawPrice || '').replace(/[^\d]/g, ''), 10) || '';
    return '<button type="button" class="ag-fav-btn"' +
      ' data-fav-id="' + id + '"' +
      ' data-fav-handle="' + e(p.handle) + '"' +
      ' data-fav-title="' + e(p.name || p.title) + '"' +
      ' data-fav-image="' + e(p.image) + '"' +
      ' data-fav-price="' + price + '"' +
      ' data-fav-variant="' + e(p.variantId || p.variant_id) + '"' +
      (src ? ' data-fav-source="' + src + '"' : '') +
      '></button>';
  }

  // ---------- Clics (captura: evita que la tarjeta navegue) ----------
  document.addEventListener('click', e => {
    const btn = (e.target.closest && e.target.closest('.ag-fav-btn')) || hitFav(e);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  }, true);

  // ---------- Botones agregados después (AJAX, buscador) ----------
  let raf = 0;
  new MutationObserver(muts => {
    if (raf) return;
    const hasBtn = muts.some(m => [...m.addedNodes].some(n =>
      n.nodeType === 1 && (n.matches('.ag-fav-btn') || n.querySelector('.ag-fav-btn'))
    ));
    if (!hasBtn) return;
    raf = requestAnimationFrame(() => { raf = 0; paint(); });
  }).observe(document.body, { childList: true, subtree: true });

  // ---------- Aviso a anónimos: iniciar sesión ----------
  const PROMPT_KEY = 'ag_fav_login_prompt';

  function showLoginPrompt() {
    if (window.AGFav.loggedIn) return;
    if (location.pathname.startsWith('/pages/favoritos')) return;
    try {
      if (sessionStorage.getItem(PROMPT_KEY)) return;
      sessionStorage.setItem(PROMPT_KEY, '1');
    } catch (e) {}

    const old = document.getElementById('agFavToast');
    if (old) old.remove();

    const t = document.createElement('div');
    t.id = 'agFavToast';
    t.className = 'ag-fav-toast';
    t.setAttribute('role', 'status');
    t.innerHTML = `
      <div class="ag-fav-toast-icon">${HEART}</div>
      <div class="ag-fav-toast-body">
        <div class="ag-fav-toast-title">Guardado en favoritos</div>
        <div class="ag-fav-toast-text">Inicia sesión para no perderlos y verlos en cualquier dispositivo.</div>
        <div class="ag-fav-toast-actions">
          <a href="/account/login" class="ag-fav-toast-btn">Iniciar sesión</a>
          <a href="/pages/favoritos" class="ag-fav-toast-link">Ver favoritos</a>
        </div>
      </div>
      <button type="button" class="ag-fav-toast-close" aria-label="Cerrar">✕</button>`;
    document.body.appendChild(t);
    requestAnimationFrame(() => t.classList.add('is-visible'));

    const hide = () => {
      t.classList.remove('is-visible');
      setTimeout(() => t.remove(), 300);
    };
    t.querySelector('.ag-fav-toast-close').addEventListener('click', hide);
    setTimeout(hide, 9000);
  }

  // ---------- Prueba social en la ficha de producto ----------
  const SOCIAL_MIN = 2;

  function renderSocial(el) {
    const n = Number(el.dataset.count || 0);
    const stock = parseInt(el.dataset.stock, 10);
    if (n < SOCIAL_MIN) { el.hidden = true; return; }

    const txt = `${n} personas lo tienen en favoritos`;
    if (stock > 0 && stock <= 3) {
      const quedan = stock === 1 ? 'Queda 1' : `Quedan ${stock}`;
      el.innerHTML = `${HEART}<span><strong>${quedan}</strong> · ${txt}</span>`;
      el.classList.add('ag-fav-social--urgent');
    } else {
      el.innerHTML = `${HEART}<span>${txt}</span>`;
      el.classList.remove('ag-fav-social--urgent');
    }
    el.hidden = false;
  }

  async function loadSocial() {
    const els = document.querySelectorAll('[data-ag-social]');
    for (const el of els) {
      try {
        const r = await fetch(`${API}/count?product_id=${encodeURIComponent(el.dataset.productId)}`);
        const j = await r.json();
        el.dataset.count = j.favs || 0;
        renderSocial(el);
      } catch (e) {}
    }
  }

  document.addEventListener('agfav:change', e => {
    const { id, active } = e.detail;
    document.querySelectorAll(`[data-ag-social][data-product-id="${id}"]`).forEach(el => {
      el.dataset.count = Math.max(0, Number(el.dataset.count || 0) + (active ? 1 : -1));
      renderSocial(el);
    });
  });

  window.AGFav = {
    device: DEVICE,
    loggedIn: false,
    data: null,
    has: id => favs.has(String(id)),
    ids: () => [...favs],
    refresh: load,
    paint,
    btnHTML
  };

  load();
  loadSocial();
})();